import { ChangeEvent, useState } from 'react';
import { Box, Button, FormControl, NativeSelect, TextField, Typography } from '@mui/material';
import { getResult } from '../configuration';

interface Result {
  key: string;
  name: string;
  value: string | number;
}

const SubnetCalculatorInput = () => {
  const [inputValue, setInputValue] = useState<string>('');
  const [selectedOption, setSelectedOption] = useState<number>(32);
  const [result, setResult] = useState<Result[]>([]);
  const [error, setError] = useState<string | null>(null); // New state for error message
 
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    const isCIDRNotation = value.includes('/');

    if (isCIDRNotation) {
      const subnet = parseInt(value.split('/')[1]);
      if (subnet >= 1 && subnet <= 32) {
        setSelectedOption(subnet);
      }
    } else {
      setSelectedOption(32); 
    }
    value = value.replace(/\/\d*$/, '');
    setInputValue(value);

    if (isValidIPAddress(value)) {
      setError(null);
    }
  }; 
  
  const renderOptions = () => {
    const options = [];
    for (let port = 32; port >= 1; port--) {
      options.push(
        <option key={port} value={port}>
           {port}
        </option>
      );
    }
    return options;
  };

  const onSubmitCalculate = () => {
    if (!inputValue.trim()) {
      setError('Please enter a valid IPv4.');
      return;
    }
    const subnetAsNumber: number = parseInt(selectedOption.toString(), 10); // Convert to number
    if (!isValidIPAddress(inputValue)) {
      setError('Invalid IPv4.');
      return;
    }
    setError(null);
    const calculatedResult: Result[] = getResult(inputValue, subnetAsNumber);
    setResult(calculatedResult);
  };

  const isValidIPAddress = (ip: string) => {
    const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;
    return ipv4Regex.test(ip);
  };
  
  return (
    <>
      <Box className="input-wrap common-box" sx={{display:{xs:"block", sm:"flex"}}}>
        <Box display="flex" sx={{width:{xs:"100%", sm:"calc(100% - 140px)"}}}>
          <Box sx={{width:"calc(100% - 90px)"}}>
            <TextField placeholder="IP Address" variant="outlined" value={inputValue} onChange={(e:any) => {handleInputChange(e);}} autoFocus fullWidth/>
            {error && <Typography variant="body1" color="error" margin="0px !important">{error}</Typography>}
          </Box>
          <FormControl sx={{marginX:1}}>
          <NativeSelect
            className="ip-port"
            value={selectedOption}
            onChange={e => setSelectedOption(e.target.value as unknown as number)}
            inputProps={{
              name: 'age',
              id: 'uncontrolled-native',
            }}
          >
            {renderOptions()}
          </NativeSelect>
        </FormControl>
        </Box>
        <Box sx={{marginTop:{xs:1, sm:0}}}>
          <Button variant="contained" onClick={onSubmitCalculate} >Calculate</Button>
        </Box>
      </Box>
      {result.length > 0 && (
      <Box className="ip-result common-box" sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent:"center",
        "& .ip-result-item": {
          flex: "0 0 25%",
          maxWidth: "25%",
          textAlign: "center",
          margin:"10px 0px",
          "@media (max-width:767px)": {
            flex: "0 0 50%",
            maxWidth: "50%",
          },
          "& .MuiTypography-root": {
            background: "rgb(230 245 255)",
            borderRadius: "5px",
            margin: "0px 5px !important",
            padding: "10px 5px",
            height:"100%",
            "& span": {
              display: "block",
              fontWeight: "bold",
            },
          },
        },
      }}
      >
        {result.map((item, index) => (
          <Box key={index} className="ip-result-item"><Typography variant='body1'><span>{item.name}: </span>{item.value}</Typography></Box>
        ))}
      </Box>
    )}
    </>
  );
};

export default SubnetCalculatorInput;
